import { testimonials, fieldProven } from "../../content/testimonials";
import styles from "./Testimonials.module.css";

interface TestimonialsProps {
  // The host page's language. Passed as a prop (not read from Redux) because
  // the marketing pages derive language from the URL, which can disagree with
  // the Redux language preference; the section must match the page around it.
  lang: "tr" | "en";
}

const UI = {
  tr: {
    title: "Sahada kanıtlandı",
    subtitle: "Gerçek bir istasyonun günlük operasyonunda",
    quotesTitle: "İstasyonlar ne diyor?",
    website: "İstasyonun web sitesi",
    maps: "Google Haritalar'da gör",
    badge: "Gerçek kullanım",
  },
  en: {
    title: "Proven in the field",
    subtitle: "In the daily operations of a real station",
    quotesTitle: "What stations say",
    website: "Station website",
    maps: "See on Google Maps",
    badge: "Real-world use",
  },
};

/**
 * Social-proof section: the field-proven (dogfooding) story of the maker's own
 * station, plus customer quotes from src/content/testimonials.ts once real,
 * approved ones exist (the quote grid renders nothing while the list is
 * empty). Deliberately carries no schema.org Review/AggregateRating markup:
 * plain quotes are not ratings, and unearned review markup risks a Google
 * penalty.
 */
function Testimonials({ lang }: TestimonialsProps): JSX.Element {
  const ui = UI[lang];

  return (
    <section className={styles.section} aria-labelledby="testimonials-title">
      <div className={styles.header}>
        <h2 id="testimonials-title" className={styles.title}>
          {ui.title}
        </h2>
        <p className={styles.subtitle}>{ui.subtitle}</p>
      </div>

      <div className={styles.fieldProven}>
        <span className={styles.badge}>{ui.badge}</span>
        <p className={styles.fieldProvenText}>{fieldProven.description[lang]}</p>
        <div className={styles.fieldProvenLinks}>
          <a
            href={fieldProven.websiteUrl}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.fieldProvenLink}
          >
            {ui.website} ↗
          </a>
          <a
            href={fieldProven.mapsUrl}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.fieldProvenLink}
          >
            {ui.maps} ↗
          </a>
        </div>
      </div>

      {testimonials.length > 0 && (
        <>
          <h3 className={styles.quotesTitle}>{ui.quotesTitle}</h3>
          <div className={styles.grid}>
            {testimonials.map((t) => (
              <figure key={t.id} className={styles.card}>
                <blockquote className={styles.quote}>
                  “{t.quote[lang]}”
                </blockquote>
                <figcaption className={styles.attribution}>
                  <span className={styles.name}>{t.name}</span>
                  <span className={styles.company}>
                    {t.role ? `${t.role[lang]} · ` : ""}
                    {t.company}
                  </span>
                </figcaption>
              </figure>
            ))}
          </div>
        </>
      )}
    </section>
  );
}

export default Testimonials;
